export type AdsRegistration =
  | { registered: false; status: null; registeredAt: null }
  | { registered: true; status: 'REGISTERED'; registeredAt: string }

export function parseAdsRegistration(value: unknown): AdsRegistration {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const result = value as Record<string, unknown>

    if (result.registered === false && result.status === null && result.registeredAt === null) {
      return { registered: false, status: null, registeredAt: null }
    }

    if (result.registered === true && result.status === 'REGISTERED'
      && typeof result.registeredAt === 'string' && Number.isFinite(Date.parse(result.registeredAt))) {
      return { registered: true, status: 'REGISTERED', registeredAt: result.registeredAt }
    }
  }

  throw new Error('Invalid ads registration response')
}
